angular.module('impactx.search').component('ixCardTabContainer', {
        bindings: {
            trns: '<',
            isOpen: '=',
            onContentUpdate: '&'
        },
        controller: 'CardTabContainerCtrl',
        controllerAs: 'containerCtrl',
        templateUrl: 'modules/search/templates/card-tab-container.html',
        transclude: true
    }
);